import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "value", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('inventaire__left__accord-checkbox ' + _ctx.group)
  }, [
    _createElementVNode("label", null, [
      _createElementVNode("input", {
        type: "checkbox",
        class: "checkboxreset",
        id: _ctx.id,
        value: _ctx.value,
        checked: _ctx.isChecked === true
      }, null, 8, _hoisted_1),
      _createTextVNode(" " + _toDisplayString(_ctx.value == "Pick-up" ? "Pickup" : _ctx.toUpperCase(_ctx.value)) + " ", 1),
      _createElementVNode("span", null, " [" + _toDisplayString(_ctx.total) + "] ", 1)
    ])
  ], 2))
}